import { useUserStore } from "@voix/store/userStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
import { navigateTo, useCookie } from "#imports";
function setCurrentUserInStore(response) {
  if (response) {
    const userStore = useUserStore();
    userStore.currentUser = response;
  }
}
const getCurrentUser = async () => {
  const userStore = useUserStore();
  const accessToken = useCookie("auth-access-token");
  if (!accessToken.value)
    return { pending: false, data: { value: null } };
  const request = await $voixNuxtApi(
    `/api/admin/voix/users/me`
  );
  if (request.error.value && request.error.value.statusCode === 401) {
    userStore.logout();
    navigateTo({
      path: "/"
    });
  }
  setCurrentUserInStore(request.data.value);
  return request;
};
export { getCurrentUser };
